export default {
      id: "icon-urn-usage",
      viewBox: "0 0 14 17",
      url: "/" + "assets/sprite.svg#icon-urn",
      toString: function () {
        return this.url;
      }
    }